<template>
  <div v-if="buttons.length" class="approved-buttons">
    <ContentLink
      v-for="button in buttons"
      :key="button.number"
      :to="button.link"
      :class="buttonClass"
      >{{ button.label }}<ArrowIcon
    /></ContentLink>
  </div>
</template>
<script>
import ContentLink from './ContentLink.vue';
import ArrowIcon from './ArrowIcon.vue';
import { contentValue, plainText, safeLink } from '@/services/contentApi';
export default {
  name: 'RecordButtons',
  components: { ContentLink, ArrowIcon },
  props: { item: Object, screen: Object, buttonClass: { type: String, default: 'text-link' } },
  computed: {
    buttons() {
      return [1, 2, 3, 4]
        .map((number) => ({
          number,
          link: this.has(`iti_linkbtn${number}`)
            ? safeLink(contentValue(this.item, `iti_linkbtn${number}`))
            : '',
          label: this.has(`iti_textobtn${number}`)
            ? plainText(contentValue(this.item, `iti_textobtn${number}`))
            : '',
        }))
        .filter((b) => b.link && b.label);
    },
  },
  methods: {
    has(field) {
      return this.screen.campos.some((f) => f.campo === field);
    },
  },
};
</script>
